"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HToken = exports.WrappedToken = exports.CanonicalToken = exports.ChainId = exports.NetworkSlug = exports.Slug = exports.ChainSlug = exports.eventTopics = exports.TokenModel = exports.TokenAmount = exports.Route = exports.Chain = exports.Token = exports.AMM = exports.CanonicalBridge = exports.HopBridge = exports.Hop = void 0;
const Hop_1 = __importDefault(require("./Hop"));
exports.Hop = Hop_1.default;
var HopBridge_1 = require("./HopBridge");
Object.defineProperty(exports, "HopBridge", { enumerable: true, get: function () { return __importDefault(HopBridge_1).default; } });
var CanonicalBridge_1 = require("./CanonicalBridge");
Object.defineProperty(exports, "CanonicalBridge", { enumerable: true, get: function () { return __importDefault(CanonicalBridge_1).default; } });
var AMM_1 = require("./AMM");
Object.defineProperty(exports, "AMM", { enumerable: true, get: function () { return __importDefault(AMM_1).default; } });
var Token_1 = require("./Token");
Object.defineProperty(exports, "Token", { enumerable: true, get: function () { return __importDefault(Token_1).default; } });
var models_1 = require("./models");
Object.defineProperty(exports, "Chain", { enumerable: true, get: function () { return models_1.Chain; } });
var models_2 = require("./models");
Object.defineProperty(exports, "Route", { enumerable: true, get: function () { return models_2.Route; } });
var models_3 = require("./models");
Object.defineProperty(exports, "TokenAmount", { enumerable: true, get: function () { return models_3.TokenAmount; } });
Object.defineProperty(exports, "TokenModel", { enumerable: true, get: function () { return models_3.Token; } });
__exportStar(require("./types"), exports);
var constants_1 = require("./constants");
Object.defineProperty(exports, "eventTopics", { enumerable: true, get: function () { return constants_1.eventTopics; } });
var constants_2 = require("./constants/constants");
Object.defineProperty(exports, "ChainSlug", { enumerable: true, get: function () { return constants_2.ChainSlug; } });
Object.defineProperty(exports, "Slug", { enumerable: true, get: function () { return constants_2.Slug; } });
Object.defineProperty(exports, "NetworkSlug", { enumerable: true, get: function () { return constants_2.NetworkSlug; } });
Object.defineProperty(exports, "ChainId", { enumerable: true, get: function () { return constants_2.ChainId; } });
Object.defineProperty(exports, "CanonicalToken", { enumerable: true, get: function () { return constants_2.CanonicalToken; } });
Object.defineProperty(exports, "WrappedToken", { enumerable: true, get: function () { return constants_2.WrappedToken; } });
Object.defineProperty(exports, "HToken", { enumerable: true, get: function () { return constants_2.HToken; } });
if (typeof window !== 'undefined') {
    ;
    window.Hop = Hop_1.default;
}
